/*
 * @Author: wangshengqiang
 * @Date: 2021-05-07 10:23:17
 * @LastEditTime: 2021-10-28 11:19:58
 * @LastEditors: wangshengqiang
 * @Description: 产品资料组件
 */
import classnames from 'classnames';
import React from 'react';
import holder from '@/assets/images/holderPg.png';
import './index.less';

const InformationList = props => {
  const {
    attrs
  } = props;
  const {
    dataSource,
    className
  } = attrs;
  const cls = classnames({
    'components-information-container': true,
    [className]: !!className
  });

  const clickHandle = data => {
    // 储存
    const {
      origin
    } = window.location;
    sessionStorage.setItem('infoDetails', JSON.stringify(data));
    window.location.href = `${origin}/infoDetails`;
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cls
  }, dataSource.map(item => {
    var _item$imgs$;

    return /*#__PURE__*/React.createElement("div", {
      onClick: () => clickHandle(item)
    }, /*#__PURE__*/React.createElement("img", {
      src: ((_item$imgs$ = item.imgs[0]) === null || _item$imgs$ === void 0 ? void 0 : _item$imgs$.imageUrl) || holder,
      alt: "\u8D44\u6599\u56FE"
    }), /*#__PURE__*/React.createElement("div", null, item.title));
  }));
};

export default InformationList;